var isFiniteNumber = (value) => {
    return typeof value == 'number' && isFinite(value);
};

export default isFiniteNumber;
